const checkSelected = (filterForm) => {
  const onChangeFilter = (evt) => {
    if (evt.target.getAttribute(`type`) === `checkbox`) {
      const checkedElements = Array.from(filterForm[evt.target.name]).filter(
        (element) => element.checked,
      );

      if (checkedElements.length) {
        evt.target.closest(`.js-collapse`).dataset.checked = `true`;
      } else {
        evt.target.closest(`.js-collapse`).dataset.checked = `false`;
      }
    }
  };

  filterForm.addEventListener(`change`, onChangeFilter);
};

export default checkSelected;
